require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-entree-peperbus.json") })
        }
      }, "path---projecten-entree-peperbus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-entree-peperbus!./.cache/json/projecten-entree-peperbus.json
// module id = 412
// module chunks = 231608221292675